<template>
<div class="input-group input-group-outline input-add mb-3 has-validation" 
v-bind:class="{ 'focused is-focused': focused}">
    <label class="form-label">{{label}}</label>
    <input
        type="text"
        v-model="txt"
        :class="'form-control ' + c_css"
        :maxlength="maxlength"
        :minlength="minlength"
        :autocomplete="autocomplete"
        @focus="focused=!focused"
        @blur="focused=!focused"
        readonly="readonly"
        />
        <button type="button" class="btn" @click="$emit('input', txt); txt=null">{{btn}}</button>
</div>
</template>
<script>
export default {
  props:{    
    
    btn : { type: String , required: false, default: 'Adicionar'},
    label: { type: String , required: false, default: ''},
    placeholder: { type: String, required: false, default: ''},
    c_css: { type: String, required: false, default: ''},
    maxlength: { type: String, required: false, default: ''},
    minlength: { type: String, required: false, default: ''},
    autocomplete: { type: String, required: false, default: ''},
  },
  mounted(){
    let input = this.$el.children[1];
    setTimeout(() => {
      input.removeAttribute("readonly");
    }, 500);
  },
  data() {
    return {
      focused:  false,
      txt: null,
    }
  }
}
</script>